import { useSelector } from "react-redux";
import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";



export const getSubstores = async (company_id, user_id) => {
  console.log("GOT USER ID", user_id);
  
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      ...(user_id && {user_id:user_id}),
    };
    const response = await axiosInstance.post(URLS.GET_SUB_STORE, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};


export const getSubStoreDetails = async (sub_store_id, lang) => {
  try {
    const res = await axiosInstance.post(URLS.GET_SUB_STORE_DATA, {
      sub_store_id,
      lang,
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching sub-store details:", error);
    throw error;
  }
};

export const getWarehouseDetails = async (warehouse_id, lang) => {
  try {
    const res = await axiosInstance.post(URLS.GET_WAREHOUSE_DATA, {
      warehouse_id,
      lang,
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching sub-store details:", error);
    throw error;
  }
};


export const activateSubStore = async (subStoreId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      sub_store_id: subStoreId,
    };

    const response = await axiosInstance.post(URLS.ACTIVATE_STORE_BRANCH, payload);

    if (response.data?.result?.status_code === 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error activating substore:", error);
    throw error; // Re-throwing the error for error handling in calling components
  }
};

export const activateWarehouse = async (subStoreId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      warehouse_id: subStoreId,
    };

    const response = await axiosInstance.post(URLS.ACTIVATE_WAREHOUSE, payload);

    if (response.data?.result?.status_code === 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error activating substore:", error);
    throw error; // Re-throwing the error for error handling in calling components
  }
};


export const deactivateSubStore = async (subStoreId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      sub_store_id: subStoreId,
    };

    const response = await axiosInstance.post(URLS.DEACTIVATE_STORE_BRANCH, payload);

    if (response.data?.result?.status_code === 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error deactivating substore:", error);
    throw error; // Re-throwing the error for error handling in calling components
  }
};

export const deactivateWarehouse = async (subStoreId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      warehouse_id: subStoreId,
    };

    const response = await axiosInstance.post(URLS.DEACTIVATE_WAREHOUSE, payload);

    if (response.data?.result?.status_code === 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error deactivating substore:", error);
    throw error; // Re-throwing the error for error handling in calling components
  }
};

export const deleteSubStore = async (subStoreId) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      sub_store_id: subStoreId,
    };

    const response = await axiosInstance.post(URLS.DELETE_STORE_BRANCH, payload);

    if (response.data?.result?.status_code === 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error deleting substore:", error);
    throw error; // Re-throwing the error for error handling in calling components
  }
};


export const GetRetailerDetails = async (user_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
    };
    const response = await axiosInstance.post(URLS.GET_RETAILER_DETAILS, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};



export const AddBankAccount = async (payload) => {
  try {
    // const payload = {
    //   lang: i18next.language === "ar" ? "ar_001" : "en_US",
    //   company_id: company_id,
    //   accounts: [accountData],
    // };

    const response = await axiosInstance.post(URLS.ADD_BANK_ACCOUNT, payload);

    console.log("AddBankAccount response:", response);


    if (response.data?.result?.status_code === 200) {
      return response.data.result;
    } else {
      // You can return entire response or a custom error object here
      return response;
    }
  } catch (error) {
    return error;
  }
};


export const GetBankDetails = async (company_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
    };
    const response = await axiosInstance.post(URLS.GET_BANK_DETAILS, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};



export const GetBankList = async () => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      // maybe company_id or store_id if needed by API
    };
    const response = await axiosInstance.post(URLS.GET_BANK_LIST, payload);
    if (response.data?.result?.status_code === 200) {
      return response.data.result.response; // or whatever field has the list
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching bank list", error);
    return [];
  }
};



export const EditBankAccount = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_BANK_ACCOUNT, payload);
    return response;
  } catch (error) {
    console.error("Error editing bank account", error);
    throw error;
  }
};



export const UpdateRetailerDetails = async (payload) => {
  try {
    //   const payload = {
    //     user_id: user_id,
    //   };
    const response = await axiosInstance.post(URLS.UPDATE_RETAILER_DETAILS, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};


export const ShopImageUpload = async (company_id, base64Image, imageName) => {

  const extension = base64Image.split(';')[0].split('/')[1];
  const filename = `${imageName}.${extension}`;
  const base64Data = base64Image.split(',')[1];
  // console.log("BASE CHALA", base64Data);


  const payload = {
    filename: filename,
    bucket: process.env.REACT_APP__IMAGE_BUCKET,
    data: base64Data,
  };

  try {
    const response = await axiosInstance.post(process.env.REACT_APP__IMAGE_UPLOAD, payload, {
    });

    if (response.data && response.data.result && response.data.result.status_code === 200) {
      return response.data.result.url;
    } else {
      console.error("Upload failed:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

export const RetailerShopImagesUpload = async (payload) => {
  try {
    //   const payload = {
    //     user_id: user_id,
    //   };
    const response = await axiosInstance.post(URLS.RETAILER_SHOP_IMAGE_UPLOAD, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};


export const GetRetailerDocs = async (user_id) => {
  try {
    const payload = {
      user_id: user_id,
    };
    const response = await axiosInstance.post(URLS.GET_RETAILER_DOCS, payload);

    if (response.data?.result?.status_code == 200) {
      return response?.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};


export const GetRetailerContract = async (company_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_RETAILER_CONTRACT,
      payload
    );

    if (response.data?.result?.status_code === 200) {
      return response.data.result;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error fetching retailer contract:", error);
    return error;
  }
};